module.exports = __webpack_public_path__ + "img/about-history-left.aa98b97f.png";